export default "__VITE_ASSET__7bbreceQ__"